import { ApiResourceMethod } from '@/api/api-requests-factory';
import { FileDataResponse } from '@/models/file-data-response.model';
import { LogListRequestModel } from '@/models/logs-page/logs-list.model';
import { clearObj } from '@marfa/bo-utils';

export default class GetLogListReportRequest extends ApiResourceMethod<FileDataResponse> {
  public perform(params: LogListRequestModel) {
    const requestData = { ...params };

    return this.performer.requestWithMapper(
      { params: clearObj(requestData) },
    );
  }
}
